/**
 * Modifies existing array and inserts into a array using splice.
 *
 * If the index is larger than length - 1 it's inserted last
 * If it is less than 0 it is inserted at the beginning.
 */
export function insert<T>(arr: T[], index: number, ...items: T[]) {
  if (index >= arr.length) index = arr.length; // Add to end
  else if (index <= 0) index = 0; // Add to beginning
  arr.splice(index, 0, ...items);
}
